import { getClosestTableRow } from '@lib/popups';
import { PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { StakeholderSelector } from '@ui/StakeholderSelector';
import { StakeholderType } from '@sonar-software/sonar-core';
import React, { useCallback } from 'react';
import { useApplicationReference, useUpdateDataSecurityApp } from '@hooks';
export const AppGroupCellEditor = ({ applicationId }) => {
    const { request } = useUpdateDataSecurityApp();
    const { stakeholderGroupId } = useApplicationReference(applicationId);
    const handleOnChange = useCallback((value) => {
        if (stakeholderGroupId !== value) {
            request({
                applicationId,
                stakeholderGroupId: value !== null && value !== void 0 ? value : null
            });
        }
    }, [applicationId, request, stakeholderGroupId]);
    return (React.createElement(StakeholderSelector, { getPopupContainer: getClosestTableRow, isSpreadsheet: true, onChange: handleOnChange, placeholder: PLACEHOLDERS_COPY.SELECT_APP_GROUP, stakeholderType: StakeholderType.Team, value: stakeholderGroupId }));
};
